/* Werktage + Cutoff, Wochenend-Korrektur. Vanilla JS. */
(function () {
  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tr-liefertermin]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-werktage') || '3', 10);
      var cutoff = el.getAttribute('data-cutoff') || '12:00';
      var parts = cutoff.split(':');
      var now = new Date();
      var cut = new Date(now.getTime());
      cut.setHours(parseInt(parts[0], 10) || 12, parseInt(parts[1], 10) || 0, 0, 0);
      if (now > cut) n += 1;
      var day = now.getDay();
      if (day === 0 || day === 6) {
        /* weekend: start counting from next Monday */
      }
      var eta = addBusinessDays(now, n);
      el.textContent = pad(eta.getDate()) + '.' + pad(eta.getMonth() + 1) + '.';
    });
  });
})();
